import { PartnerType } from '@/app/utils/partners.enum'
import { streamRequest, StreamOptions } from '../http/sseClient'

export interface GetFilesResponse {
  codigoDocumento: string
  nomeDocumento: string
  urlDocumento: string
}
export async function getFiles(
  clientId: string,
  type?: PartnerType,
  options?: StreamOptions,
) {
  return streamRequest<GetFilesResponse[]>({
    method: 'GET',
    path: `/crefisa/files/${clientId}`,
    params: { type },
    ...options,
  })
}
